module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"_high":"H","_medium":"M","_low":"L","ipv6_high":" ","ipv6_medium":" ","ipv6_low":" ","url":"Domain"},"nl":{"_high":"H","_medium":"M","_low":"L","ipv6_high":" ","ipv6_medium":" ","ipv6_low":" ","url":"Domein"}}')
  delete Component.options._Ctor
}
